// AI Generated Component
import { Component, Input } from '@angular/core';
import { DomainRepoService } from '@client/app/services/api/domain-repo/domain-repo.service';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'form-user-domains',
    templateUrl: './domains.component.html',
    standalone: false,
})
export class FormUserDomainsComponent extends BaseContainerComponentController {
    @Input() user: any;

    domains: any[] = [];
    domainGroups: any[] = [];
    total = 0;
    progress: any;

    constructor (
        private domainRepoService: DomainRepoService,
    ) {
        super({ table: true });
    }

    ngOnInit () {
        this.init();
    }

    init () {
        this.user.domain_users = this.user.domain_users || [];
        this.user.domain_group_members = this.user.domain_group_members || [];
        this.domainGroups = [];
        this.domains = [];
        this.total = 0;
        this.getPage();
    }

    override getPage = () => {
        this.progress = this.domainRepoService.getAll({ page_size: this.pageSize, page: this.page, mini: true }).then(domains => {
            this.domains = domains;
            this.total = domains.total || 0;
        });
    };

    setDomain (domain: any, userParam: string, domainParam: string) {
        const index = this.getIndexOfUserDomain(domain, userParam, domainParam);
        if (index === -1) {
            const params: any = {
                visible: false,
                send_report: false,
            };
            params[domainParam] = domain.id;
            this.user[userParam].push(params);
        }
    }

    domainIsVisible (domain: any): boolean {
        return this.isVisible(this.user.domain_users, domain, 'domain_id');
    }

    domainGroupIsVisible (domain: any): boolean {
        return this.isVisible(this.user.domain_group_members, domain, 'domain_group_id');
    }

    isVisible (domains: any[], domain: any, attr: string): boolean {
        if (Boolean(this.user.customer_admin) === false) {
            for (let i = 0; i < domains.length; i++) {
                if (domains[i][attr] === domain.id) {
                    return domains[i].visible;
                }
            }
        }
        return Boolean(this.user.customer_admin);
    }

    domainHasSendReport (domain: any): boolean {
        return this.hasSendReport(this.user.domain_users, domain, 'domain_id');
    }

    domainGroupHasSendReport (domain: any): boolean {
        return this.hasSendReport(this.user.domain_group_members, domain, 'domain_group_id');
    }

    hasSendReport (domains: any[], domain: any, attr: string): boolean {
        for (let i = 0; i < domains.length; i++) {
            if (domains[i][attr] === domain.id) {
                return domains[i].visible && domains[i].send_report;
            }
        }
        return false;
    }

    setVisible (domain: any, userParam: string, domainParam: string) {
        let index = this.getIndexOfUserDomain(domain, userParam, domainParam);
        if (index === -1) {
            this.setDomain(domain, userParam, domainParam);
            index = this.user[userParam].length - 1;
        }
        this.user[userParam][index].visible = !this.isVisible(this.user[userParam], domain, domainParam);
    }

    setSendReport (domain: any, userParam: string, domainParam: string) {
        let index = this.getIndexOfUserDomain(domain, userParam, domainParam);
        if (index === -1) {
            this.setDomain(domain, userParam, domainParam);
            index = this.user[userParam].length - 1;
        }
        this.user[userParam][index].send_report = !this.hasSendReport(this.user[userParam], domain, domainParam);
    }

    getIndexOfUserDomain (domain: any, userParam: string, domainParam: string): number {
        for (let i = 0; i < this.user[userParam].length; i++) {
            if (this.user[userParam][i][domainParam] === domain.id) {
                return i;
            }
        }
        return -1;
    }

    trackByIndex (index: number, item: any): number {
        return index;
    }

    trackByDomainGroupIndex (index: number, item: any): number {
        return index;
    }
}
